import { IPagedResultsV1 } from '@gcl/react-core';
import { IProjectSettings } from 'src/projectSettings/projectSettings.models';

export interface IProject {
  id: number;
  projectName?: string;
  address?: string;
  description?: string;
  projectNo?: string;
  type?: IProjectType;
  typeId?: number;
  regionId?: number;
  tel?: string;
  fax?: string;
  email?: string;
  startDate?: string;
  finishDate?: string;
  siteAdmin?: string;
  rowVersion?: string;
  projectSettings?: IProjectSettings[];
  isArchived?: boolean;
  isInterested?: boolean;
}
export interface IProjectType {
  id: number;
  name?: string;
}

export const projectSearchKeys = {
  PROJECT_NO: 'projectNo',
  PROJECT_NAME: 'projectName',
  ADDRESS: 'address',
  TYPE: 'type',
  TEL: 'tel',
  FAX: 'fax',
  EMAIL: 'email',
  START_DATE: 'startDate',
  FINISH_DATE: 'finishDate',
  SITE_ADMIN: 'siteAdmin',
  DESCRIPTION: 'description',
};

export interface IProjectSearchFilter {
  keyword?: string;
  isArchived?: boolean;
}

export interface IProjectSearchFilterResponse extends IPagedResultsV1<IProject> {}

export interface IUpsertProjectRequestBase {
  id: number;
  projectNo: string;
  projectName?: string;
  typeId?: number;
  address?: string;
  description?: string;
  tel?: string;
  fax?: string;
  email?: string;
  startDate?: string;
  finishDate?: string;
  siteAdmin?: string;
  rowVersion?: string;
}

export interface IUpdateProjectRequest extends IUpsertProjectRequestBase {}

export interface IProjectInterested {
  id: number;
  projectId: number;
}
